import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';
import { StaffUserState } from 'types/staff-user/staff-user-state';

const initialState: StaffUserState = {
    staffUser: localStorage.getItem('staffUser')
        ? JSON.parse(localStorage.getItem('staffUser') as string)
        : null,
};

export const staffUserSlice = createSlice({
    name: 'staffUser',
    initialState,
    reducers: {
        setStaffUser: (
            state: StaffUserState,
            action: PayloadAction<StaffUserState['staffUser']>,
        ) => {
            state.staffUser = action.payload;
        },
        /*setStatus: (state: StaffUserState, action: PayloadAction<string>) => {
            if (!state.staffUser) {
                return;
            }
            state.staffUser.status = action.payload;
        },
        logOutStaffUser: (state: StaffUserState) => {
            state.staffUser = null;
        },*/
    },
    extraReducers: (builder) =>
        builder.addCase(logOutStaffUser, (state) => {
            state.staffUser = null;
        }),
});

export const logOutStaffUser = createAction('logOutStaffUser');

export const { setStaffUser } = staffUserSlice.actions;

export default staffUserSlice.reducer;

export const selectCurrentStaffUser = (state: RootState) =>
    state.staffUser.staffUser;
